// Импорт и механики — только с правом правки вопросов (manage)
export default [
  {
    header: 'Вопросы',
    resource: 'questions',
    action: 'view',
  },
  {
    title: 'Список вопросов',
    route: 'questions',
    icon: 'HelpCircleIcon',
    resource: 'questions',
    action: 'view',
  },
  {
    title: 'Хранилище',
    route: 'question-storage',
    icon: 'DatabaseIcon',
    resource: 'questions',
    action: 'view',
  },
  {
    title: 'Импорт пакета',
    route: 'question-storage-import',
    icon: 'UploadIcon',
    resource: 'questions',
    action: 'manage',
  },
  {
    title: 'Механики',
    route: 'question-mechanics',
    icon: 'SlidersIcon',
    resource: 'questions',
    action: 'manage',
  },
]
